import styled from 'styled-components';

export const CubeContainer = styled.div``;
